export function calCelsius ( temp){
    let cell = parseFloat(temp) - 273.15
    return cell
}

